import React from "react";
import { UserFraudReason } from "@/src/types/user";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/src/components/ui/table";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/src/components/ui/card";
import { formatDateTime } from "@/src/lib/utils";

interface FraudTableProps {
  frauds: UserFraudReason[];
}

export function FraudTable({ frauds }: FraudTableProps) {
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle>Fraud</CardTitle>
      </CardHeader>
      <CardContent>
        {frauds.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Created At</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {frauds.map((fraud: UserFraudReason, index) => (
                <TableRow key={`fraud-${index}`}>
                  <TableCell>{fraud.name}</TableCell>
                  <TableCell>{formatDateTime(fraud.createdAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="text-center py-4">No fraud reasons found</div>
        )}
      </CardContent>
    </Card>
  );
}
